import React from "react";
import logo from "../images/logo.png";
import "./LoadingAnimations.css";

const ActiveSessionLoadingState = ({
	message = "Loading active session...",
}) => {
	return (
		<section className="flex flex-col justify-center mt-1 mb-5 md:mx-mdPagePadding md:px-mdPagePadding lg:px-lgPagePadding lg:mx-lgPagePadding xl:px-xlPagePadding xl:mx-xlPagePadding">
			{/* Logo */}
			<div className="flex flex-col justify-center items-center float-animation">
				<img src={logo} alt="logo" className="w-40 h-auto object-contain" />
			</div>

			{/* Loading Active Session Card */}
			<div className="mx-smPagePadding bg-blue-50 border border-blue-200 flex flex-col justify-center items-center text-center py-5 px-2 rounded-primary slide-in-down animate-delay-200">
				<div className="h-6 skeleton-shimmer rounded w-32 mb-4"></div>
				<div className="px-3 py-2 border-l-2 border-gray-300 mb-2 w-full">
					<div className="space-y-2 text-left">
						<div className="h-4 skeleton-shimmer rounded w-full"></div>
						<div className="h-4 skeleton-shimmer rounded w-3/4 animate-delay-100"></div>
						<div className="h-4 skeleton-shimmer rounded w-5/6 animate-delay-200"></div>
					</div>
				</div>
				{/* Timer Skeleton */}
				<div className="py-2 px-4 bg-white rounded-secondary border border-gray-200 mt-4 flex flex-row justify-center items-center">
					<div className="h-5 skeleton-shimmer rounded w-32"></div>
				</div>
			</div>

			{/* Skeleton for Booth Details */}
			<div className="border-t border-b border-gray-200 py-5 mx-smPagePadding flex flex-col justify-center items-center mt-7 animate-pulse">
				<div className="flex justify-between items-center mb-2 w-full">
					<div className="flex gap-8 text-textSecondary w-full">
						<div className="h-4 bg-gray-300 rounded w-24"></div>
						<div className="h-4 bg-gray-300 rounded w-20"></div>
					</div>
				</div>
				<div className="flex items-center gap-3 text-textSecondary">
					<div className="h-4 bg-gray-300 rounded w-32"></div>
					<div className="h-4 w-px bg-gray-300"></div>
					<div className="h-4 bg-gray-300 rounded w-16"></div>
				</div>
			</div>

			{/* Skeleton for QR Code */}
			<div className="mx-smPagePadding flex flex-col justify-center items-center rounded-primary mt-4 animate-pulse">
				<div className="w-44 h-44 bg-gray-300 rounded-lg flex items-center justify-center">
					<div className="w-32 h-32 bg-gray-400 rounded opacity-50"></div>
				</div>
			</div>

			{/* Subtle background animation */}
			<div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
				<div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-50 rounded-full opacity-10 animate-pulse"></div>
				<div
					className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-50 rounded-full opacity-10 animate-pulse"
					style={{ animationDelay: "1s" }}
				></div>
			</div>
		</section>
	);
};

export default ActiveSessionLoadingState;
